<template>
    <header class="header">
        <div class="logoWrapper">
            <Logo/>
        </div>

        <Navigation
            @openNewEntryModal="openNewEntryModal"
            @openSearchModal="$emit('openSearchModal')"/>

        <div class="globalMenu">
            <NotificationSystem class="notificationSystemWrapper"
                v-if="auth.id"/>
            <GlobalMenu class="globalMenuWrapper"/>
            <Button class="signupButton"
                v-if="!auth.id && $route.name !== 'auth'"
                url="/auth"
                appearance="secondary"
                prefixIcon="person_add_alt"
                size="small">
                {{ siteContent.signUp }}
            </Button>
        </div>
    </header>
</template>

<script>
    import Navigation from '@/components/layout/header/Navigation'
    import GlobalMenu from '@/components/layout/header/GlobalMenu'
    import NotificationSystem from '@/components/notifications/NotificationSystem'
    
    export default {
        name: 'Header',
        components: {
            Navigation,
            GlobalMenu,
            NotificationSystem
        },
        methods: {
            openNewEntryModal(mediaType) {
                this.$emit('openNewEntryModal', mediaType)
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .header {
        position: sticky;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 4rem;
        padding: 0.25rem 2rem;
        z-index: 10;
        border-radius: 0 0 1.5rem 1.5rem;
        backdrop-filter: blur(2rem);
        background: var(--color-white-40);
    }

    .globalMenu {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .signupButton {
        margin-left: 1rem;
    }

    @media all and (max-width: 1200px) {
        .header {
            position: fixed;
            top: auto;
            bottom: 0;
            border-radius: 1.5rem 1.5rem 0 0;
            padding: 0.25rem 1rem;
            justify-content: center;
        }

        .logoWrapper {
            display: none;
        }

        .notificationSystemWrapper, .globalMenuWrapper {
            display: none;
        }

        .signupButton {
            display: none !important;
        }
    }

    @media all and (max-width: 640px) {
        .header {
            justify-content: unset;
            padding: 0.25rem 0.5rem;
            padding-bottom: calc(0.25rem + env(safe-area-inset-bottom));
            height: calc(4rem + env(safe-area-inset-bottom));
        }
    }
</style>